import { useQuery } from '@tanstack/react-query';

import { IUniversityCourse, UniversityTypes } from '../models';
import { getUniversityCourse } from '../queries';
import { universitiesConst } from '..';

export const useUniversityCourse = (id?: string, type?: string) => {
  const { data: universityCourse, ...args } = useQuery<IUniversityCourse[]>({
    queryKey: [universitiesConst.queryKeys.UNIVERSITY_COURSE, id, type],
    queryFn: getUniversityCourse(id),
    enabled: !!id && type === UniversityTypes.PRIVATE
  });

  return { universityCourse, ...args };
};
